import type { FaireProductEntity } from "../../entity_types/product";

export const p_w4n28r5977: FaireProductEntity = {
  token: "p_w4n28r5977",
  type: "product",
  name: "Mahjong Tote Bag Mahjong Tile Bag Leather | Pink *NEW*",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/e9788ddbf809dad6c3848be6e94ec45f8e58d87a4c131acd174de7b30120406f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9cb24e61e78538375dd8186a8a51d1f4405cedebb17ef050b4f2e230208b66c.png",
    "https://cdn.faire.com/fastly/03cec2180b47585bff0d6fb4a15531eeb9cbf1c5e0efe1bd27d7d1d184beaed5.png",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
  ],
  priceDollars: 32,
  description:
    'Mahjong tote bag: meet your new best seller at an amazing price point with unmatched quality. We sure do love a variety colorful colorblock combination! Perfect for mahjong tile storage, mahjong gifts, mahjong tile storage, and preppy gift sections.\n\nMahjong Bag Info\n:: Saffiano Leatherette Vegan: 20"x12"x8"-fits our coordinating rack pouch and mahjong storage tile pouch.\n:: Perfect to hold mahjong card, jewelry, and other personal items\n:: Custom colorful coordinating handles\n:: Snap closure, inside pocket and satin lining.\n:: Coordinating MAHJ printed shoulder strap included\n\nSee coordinating mahjong tile pouch and mahjong tile and pusher storage pouch.',
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:37.791Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
